import { useEffect, useRef } from "react";

function SmilesRenderer({ smiles, width = 300, height = 300 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!smiles || !window.SmilesDrawer) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    // --- Handle HiDPI / Retina scaling ---
    const ctx = canvas.getContext("2d");
    const scale = window.devicePixelRatio || 1;
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(scale, scale);

    // --- Create Drawer and Render ---
    const drawer = new window.SmilesDrawer.Drawer({
      width,
      height,
      bondThickness: 1.0,
      padding: 15,
    });

    window.SmilesDrawer.parse(
      smiles,
      (tree) => {
        drawer.draw(tree, canvas, "light", false);
      },
      (err) => {
        console.error("SMILES parsing error:", err);
      }
    );
  }, [smiles, width, height]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        border: "1px solid #ccc",
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
}

export default SmilesRenderer;